import { makeObservable, observable, flow, computed, action } from "mobx";
import { toast } from "sonner";

import { api } from "@/lib/services";
import { ApiRoutes } from "@/lib/routes";
import { Add } from "@/components/icons/IconMap";

export default class BrowseBoardsStore {
  loading = false;
  pagination = {};
  query = { search: "", status: "", page: 1 };
  boards = [];

  constructor(parentStore) {
    makeObservable(this, {
      loading: observable,
      pagination: observable,
      query: observable,
      boards: observable,
      actions: computed,
      setSearchText: action,
      load: flow,
    });

    this.parentStore = parentStore;
  }

  get processing() {
    return this.loading;
  }

  get actions() {
    const list = [];
    if (this.parentStore?.parentStore?.authenticationStore?.isAdmin) {
      list.push({
        id: "demand:board:create",
        label: "New board",
        onClick: () => this.parentStore.createBoardStore.show(),
        icon: Add,
        location: "primary",
        processing: this.parentStore.createBoardStore.processing,
        disabled: this.parentStore.createBoardStore.processing,
      });
    }
    return list;
  }

  setSearchText(search) {
    this.query.search = search;
  }

  /** Idempotently provisions the tenant's Default board; safe to call on entry. */
  *ensureDefault() {
    try {
      yield api.post(ApiRoutes.forBoardEnsureDefault());
    } catch (e) {
      // Non-fatal: a member without rights or a transient failure shouldn't block the list.
      void e;
    }
  }

  *load(query) {
    try {
      this.loading = true;
      this.query = {
        search: query?.search ?? "",
        status: query?.status ?? "",
        page: query?.page ?? 1,
      };
      const response = yield api.get(ApiRoutes.forBoards(this.query));
      if (response.status === 200) {
        this.boards = response.data.items;
        this.pagination = {
          page: response.data.page,
          totalItems: response.data.totalItems,
          totalPages: response.data.totalPages,
          pageSize: response.data.pageSize,
        };
        return { success: true, data: response.data };
      }
      throw new Error("Unexpected status code");
    } catch (e) {
      toast.error("Error loading boards", {
        description: e?.response?.data?.message || "Unexpected error, please try again later.",
      });
      return { success: false, error: e };
    } finally {
      this.loading = false;
    }
  }
}
